import React from 'react';
import PropTypes from 'prop-types';
import { tiempoRelativo } from '../../Utils/notificaciones';

/**
 * Una notificación de solicitud de gasto. Es un botón: se activa con teclado y
 * lleva al detalle de la solicitud.
 */
const ItemNotificacion = ({ notificacion, onAbrir }) => (
  <button
    type="button"
    className={`notificacion-item${notificacion.read ? '' : ' notificacion-item--nueva'}`}
    onClick={() => onAbrir(notificacion)}>
    <span className="notificacion-item-punto" aria-hidden="true" />
    <span className="notificacion-item-cuerpo">
      <span className="notificacion-item-titulo">
        {notificacion.title}
        {!notificacion.read && <span className="notificacion-item-sr"> (sin leer)</span>}
      </span>
      <span className="notificacion-item-mensaje">{notificacion.message}</span>
      <span className="notificacion-item-meta">
        GTO-{notificacion.purchase_id}
        {notificacion.to ? ` · ${notificacion.to}` : ''} · {tiempoRelativo(notificacion.created_at)}
      </span>
    </span>
  </button>
);

ItemNotificacion.propTypes = {
  notificacion: PropTypes.shape({
    purchase_id: PropTypes.number,
    title: PropTypes.string,
    message: PropTypes.string,
    to: PropTypes.string,
    read: PropTypes.bool,
    created_at: PropTypes.string
  }).isRequired,
  onAbrir: PropTypes.func.isRequired
};

export default ItemNotificacion;
